const {migrateMegaMenuContainerItem} = require('./migration')

module.exports = {
    migrateMegaMenuContainerItem
}
